import { defineConfig } from "../defineConfig";
export function createProdConfig() {
  return defineConfig({
    webSocketURL: "wss://ww-twin.adago.solutions:8443",
    clientId: "ce24de0f-6da2-44bc-8b1f-ef93380d3ba2",
    redirectUri: "https://ww-twin.adago.solutions"
  });
}
